import "../Home.scss";

import { Loader } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthLogbookModal from "src/components/shared/_Modals/AuthLogbookModal/AuthLogbookModal";
import LogbookCard from "src/components/shared/LogbookCard/LogbookCard";
import CollectionBar from "src/generator/CollectionBar/CollectionBar";
import ApiErrorView from "src/components/shared/ApiErrorView/ApiErrorView";
import { useGetApi } from "src/hooks";
import { isPageApiError } from "src/interfaces/ApiError";
import { type ILogbook } from "src/interfaces";
import { useDispatch } from "src/redux/hooks";
import { setCurrentMeta } from "src/redux/slices/generatorSlice";
import { WorkspaceContainer } from "src/styled";

import { HomeLogbooks, LogbooksSection } from "../Home.styled";

function Collection() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { collectionId } = useParams();
  const [opened, { open, close }] = useDisclosure(false);
  const [clickedLbid, setClickedLbid] = useState();

  const mapCollection = useCallback(
    (data: any) => {
      const meta = data?.data?.content?.collection?.meta;
      const metaType = data?.data?.content?.meta?.data?.language;
      const collectionData = data?.data?.content?.data;
      const collection = data?.data?.content?.collection;
      const parts = data?.data?.content?.collection?.parts;
      let links;

      if (collection.links) {
        links = collection.links;
      } else if (collection.linkName && collection.link) {
        links = [{ link: collection?.link, linkName: collection?.linkName }];
      }

      const groupName = data.data.content.name;

      dispatch(
        setCurrentMeta({
          currentMeta: meta,
          currentMetaValue: metaType,
        }),
      );

      return { collectionData, parts, links, groupName, meta, metaType };
    },
    [dispatch],
  );

  const { data, isLoading, error } = useGetApi({
    request: "get-logbook",
    body: { params: { lbid: collectionId } },
    mapper: mapCollection,
  });

  const handleRestricted = useCallback(
    (token: string) => {
      navigate(`/logbook/${clickedLbid ?? ""}/partid&token=${token}`);
    },
    [clickedLbid, navigate],
  );

  const renderLogbooks = () => {
    if (data?.collectionData && data.parts) {
      return data?.collectionData.map((card: ILogbook) => (
        <LogbookCard
          {...card}
          key={card?.lbid || ""}
          open={card?.open ?? 0}
          lastentryDate={card.lastentry_date}
          lastentryTime={card.lastentry_time}
          setClickedLbid={setClickedLbid}
          openAuthModal={open}
          status={null}
        />
      ));
    } else {
      return null;
    }
  };

  if (isPageApiError(error)) {
    return <ApiErrorView error={error} />;
  }

  return (
    <>
      <AuthLogbookModal
        opened={opened}
        close={close}
        lbid={clickedLbid ?? ""}
        onSuccess={handleRestricted}
      />
      <WorkspaceContainer>
        <CollectionBar links={data?.links} groupName={data?.groupName} />
        <HomeLogbooks>
          {isLoading ? (
            <Loader />
          ) : (
            <LogbooksSection color="">{renderLogbooks()}</LogbooksSection>
          )}
        </HomeLogbooks>
      </WorkspaceContainer>
    </>
  );
}

export default Collection;
